import {useAppSelector} from 'hooks';

const useGetAvailableVouchers = () => {
  const basketVouchers = useAppSelector((state) => state.basket.basketVouchers);

  const availableVouchers =
    (basketVouchers?.unselected?.length || 0) +
    (basketVouchers?.selected?.length || 0) +
    (basketVouchers?.others?.length || 0);

  return {availableVouchers};
};

export default useGetAvailableVouchers;
